import React, { useState } from "react";
import styles from "../css/subscription.module.css";
import InfoIcon from "common-ui-components/info-icon/InfoIcon";
import { getCompareFeaturesData } from "./compareFeaturesData";

function CompareFeatures({ plans, selectedPlanIndex, onSelectPlan, product }) {
  const [open, setOpen] = useState(true);
  const data = getCompareFeaturesData(product);

  return (
    <div id="compare-plans-and-features" className={styles.compareWrapper}>
      <button
        type="button"
        className={styles.compareToggle}
        onClick={() => setOpen((prev) => !prev)}
      >
        Compare plans and features
        <span
          className={`${styles.compareChevron} ${open ? styles.compareChevronOpen : ""}`}
        >
          ▾
        </span>
      </button>

      {open && (
        <div
          className={`${styles.compareTableWrapper} ${open ? styles.compareTableOpen : ""}`}
        >
          <table className={styles.compareTable}>
            <thead>
              <tr>
                <th className={styles.compareFeaturesHead}>Features</th>
                {plans.map((plan, index) => (
                  <th
                    key={plan.planId || plan.planName}
                    className={`${styles.comparePlanHead} ${selectedPlanIndex === index ? styles.comparePlanHeadSelected : ""}`}
                  >
                    <input
                      type="radio"
                      name="comparePlan"
                      checked={selectedPlanIndex === index}
                      onChange={() => onSelectPlan(index)}
                    />
                    <span>{plan.planName} Edition</span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((group, groupIndex) => (
                <React.Fragment key={group.section || `group-${groupIndex}`}>
                  {group.section && (
                    <tr className={styles.compareSectionRow}>
                      <td
                        colSpan={plans.length + 1}
                        className={styles.compareSectionLabel}
                      >
                        {group.section}
                      </td>
                    </tr>
                  )}
                  {group.rows.map((row) => (
                    <tr key={row.key} className={styles.compareRow}>
                      <td className={styles.compareFeatureCell}>
                        {row.label}
                        {row.info && <InfoIcon content={row.info} />}
                      </td>
                      {plans.map((plan, index) => {
                        const value = row.values[plan.planName];
                        return (
                          <td
                            key={plan.planId || plan.planName}
                            className={`${styles.compareValueCell} ${selectedPlanIndex === index ? styles.compareValueCellSelected : ""}`}
                          >
                            {row.type === "boolean" ? (
                              value ? (
                                <span className={styles.compareCheck}>✓</span>
                              ) : (
                                <span className={styles.compareCross}>✕</span>
                              )
                            ) : (
                              <span>{value}</span>
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default CompareFeatures;
